import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {DealerCompany} from "../types/DealerCompany";
import {DealersResponse} from "../types/DealersResponse";

export const useGetDealers = (companyID: number) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-get-dealers', companyID],
        queryFn: async () => await apiClient.get('ee-pro/dealers') as DealersResponse,
        enabled: companyID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || {dealers: [], parentDealers: []} as DealersResponse,
        isLoading: isLoading
    };
};
